<template>
  <v-card height="100%">
    <v-card-title primary-title>
      <div class="headline">{{labels.premium}}</div>
    </v-card-title>
    <table class="v-datatable v-table theme--light" v-if="renderPremium">
      <thead>
        <tr>
          <th class="text-xs-left">Benefit</th>
          <th class="text-xs-left">Description</th>
          <th class="text-xs-left" width="100px">Rate</th>
          <th class="text-xs-right" width="200px">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="benefit in premiumInfo.benefits" :key="benefit.value" class="benefitRow">
          <td>{{benefit.value}}</td>
          <td>{{benefit.desc}}</td>
          <td>{{benefit.rate}}%</td>
          <td class="text-xs-right">{{currPrefix}} {{formatDisplayNumber(benefit.amt)}}</td>
        </tr>
        <tr v-if="checkAccess(['cargoQuoteShowBen']) && inclGst">
          <td colspan="4" class="inclGstAlert">
            <v-alert :value="true" type="info">
              Benefit(s) premium is inclusive of GST
            </v-alert>
          </td>
        </tr>
        <template v-if="showSummaryDetail">
          <tr class="summaryRow" key="premDue" v-if="checkAccess(['cargoQuoteShowDisc'])">
            <td colspan="3">
              <v-layout row wrap align-center>
                <v-flex>
                  <v-btn flat color="primary" title="Hide Details" @click="showSummaryDetail = false">
                    Hide Details
                    <v-icon right>mdi-chevron-up</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex d-flex>
                  <span class="text-xs-right">
                    Gross Premium
                  </span>
                </v-flex>
              </v-layout>
            </td>
            <td class="text-xs-right">{{currPrefix}} {{formatDisplayNumber(premiumInfo.premDue)}}</td>
          </tr>
          <tr class="summaryRow" key="premDue" v-else>
            <td colspan="4">
              <v-layout row wrap align-center>
                <v-flex>
                  <v-btn flat color="primary" title="Hide Details" @click="showSummaryDetail = false">
                    Hide Details
                    <v-icon right>mdi-chevron-up</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </td>
          </tr>
          <tr class="summaryRow" key="discAmt" v-if="checkAccess(['cargoQuoteShowDisc'])">
            <td class="text-xs-right" colspan="3">Disc Amount</td>
            <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.discPct)}}%) {{currPrefix}} {{formatDisplayNumber(premiumInfo.discAmt)}}</td>
          </tr>
          <tr class="summaryRow" key="netPremDue" v-if="checkAccess(['cargoQuoteShowDisc'])">
            <td class="text-xs-right" colspan="3">
              Net Premium
            </td>
            <td class="text-xs-right">{{currPrefix}} {{formatDisplayNumber(premiumInfo.netPremDue)}}</td>
          </tr>
          <tr class="summaryRow" key="gstAmt" v-if="checkAccess(['cargoQuoteShowDisc'])">

            <td class="text-xs-right" colspan="3">GST Amount</td>
            <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.gstRate)}}%) {{currPrefix}} {{formatDisplayNumber(premiumInfo.gstAmt)}}</td>
          </tr>
          <tr class="summaryRow" key="premiumPayable">
            <td class="text-xs-right text-label" colspan="3">Premium Payable</td>
            <td class="text-xs-right strong-value">{{currPrefix}} {{formatDisplayNumber(premiumInfo.billPremiumPayable)}}</td>
          </tr>
          <tr class="breakRow" key="breakRow" v-if="checkAccess(['cargoQuoteShowComm'])">
            <td colspan="4"></td>
          </tr>
          <tr class="summaryRow" key="commGN" v-if="checkAccess(['cargoQuoteShowComm'])">
            <td class="text-xs-right" colspan="3">Commission G/N</td>
            <td class="text-xs-right">{{premiumInfo.commGN}}</td>
          </tr>
          <tr class="summaryRow" key="commAmt" v-if="checkAccess(['cargoQuoteShowComm'])">
            <td class="text-xs-right" colspan="3">Commission Amount</td>
            <td class="text-xs-right">({{formatDisplayNumber(premiumInfo.commRate)}}%) {{currPrefix}} {{formatDisplayNumber(premiumInfo.commAmt)}}</td>
          </tr>
        </template>
        <template v-else>
          <tr class="summaryRow" key="premiumPayable2">
            <td colspan="3">
              <v-layout row wrap align-center>
                <v-flex>
                  <v-btn flat color="primary" title="Show Details" @click="showSummaryDetail = true">
                    Details
                    <v-icon right>mdi-chevron-down</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex d-flex>
                  <span class="text-label text-xs-right">Premium Payable</span>
                </v-flex>
              </v-layout>
            </td>
            <td class="text-xs-right strong-value">{{currPrefix}}{{formatDisplayNumber(premiumInfo.billPremiumPayable)}}</td>
          </tr>
        </template>
      </tbody>
    </table>
    <v-card-text v-else>
      Premium Not Available
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        premium: 'Premium Summary'
      },
      showSummaryDetail: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotePermitStatus() {
      return this.$store.getters.mtrQuoteQueryPermitStatus
    },
    renderPremium() {
      if (this.premiumInfo.premiumPayable && this.premiumInfo.premiumPayable > 0) {
        return true
      } else {
        return false
      }
    },
    premiumInfo() {
      return this.$store.state.agency.quotation.commonInfo.premium
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonForm.billCurr
    },
    inclGst() {
      if (this.premiumInfo.inclGst) {
        return true
      }
      return false
    }
  },
  methods: {
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  }
}
</script>

<style lang="scss">
.summaryRow {
  background: #eee;
  .text-label {
    font-weight: 600;
  }
  .strong-value {
    font-weight: 600;
  }
}
.breakRow {
  &:hover {
    background: inherit !important;
  }
  td {
    height: 15px !important;
  }
}
.inclGstAlert {
  .v-alert {
    margin: 0 !important;
  }
}
td.inclGstAlert {
  padding: 0 !important;
}
.permitStatus {
  padding-left: 20px;
}
</style>
